export default __webpack_public_path__ + "static/media/imac.6ed5b254.svg";